var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtflix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 44,
    viewBox: "0 0 75 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.8057 4.17371C69.4369 1.52114 66.0461 0 62.5022 0H12.4999C8.95598 0 5.5652 1.52114 3.19634 4.17371C0.833728 6.82314 -0.306949 10.3777 0.0711934 13.9229L2.09629 32.78C2.78382 39.1757 8.12781 44 14.525 44H20.9065C25.5536 44 29.7882 41.4354 31.9602 37.3026L35.1166 31.2903C35.801 29.9891 37.0073 29.8477 37.4948 29.8477C37.9823 29.8477 39.1917 29.9891 39.8762 31.2903L43.0326 37.2994C45.2045 41.4291 49.4391 43.9969 54.0862 43.9969H60.4709C66.868 43.9969 72.212 39.1726 72.8996 32.7769L74.9278 13.9197C75.309 10.3777 74.1684 6.82314 71.8026 4.17057L71.8057 4.17371ZM7.84968 8.37257C9.04973 7.02743 10.7029 6.28571 12.4999 6.28571H21.8753V9.42857C21.8753 11.1603 20.4721 12.5714 18.7502 12.5714H6.28398C6.28086 11.022 6.80275 9.54486 7.84968 8.37257ZM68.715 13.2503L66.6868 32.1074C66.343 35.3069 63.671 37.7174 60.474 37.7174H54.0893C51.7642 37.7174 49.6485 36.4351 48.5609 34.3671L45.4045 28.358C43.8513 25.4037 40.8231 23.5651 37.4979 23.5651C34.1759 23.5651 31.1445 25.4006 29.5913 28.3549L26.4349 34.3671C25.3505 36.432 23.2316 37.7143 20.9097 37.7143H14.5281C11.3311 37.7143 8.65909 35.3006 8.3122 32.1043L6.88713 18.8571H18.7471C23.916 18.8571 28.1225 14.6269 28.1225 9.42857V6.28571H62.4991C64.2992 6.28571 65.9492 7.02743 67.1524 8.37257C68.3525 9.71771 68.9087 11.4526 68.715 13.2503Z",
    fill: "url(#paint0_linear_2159_2243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2159_2243",
    x1: 2.27018,
    y1: 22,
    x2: 67.2129,
    y2: 39.8392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F68475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.275,
    stopColor: "#FCEC9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#FF7A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#B1CAEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3FFD1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtflix);
export default __webpack_public_path__ + "static/media/ctflix.589acc17959cc53eb35db4f6749ea7b5.svg";
export { ForwardRef as ReactComponent };